<div class="p--16">
  <div>
    @defer {
      @if (details$ | async; as details) {
        <div class="details-dialog__top-bar">
          <h3 class="details-dialog__headline">
            {{ 'pages.transport.detail-page.parcel' | translate }}
          </h3>
          <div>
            @if (details.carrierTrackingUrl) {
              <a class="btn btn-link" [href]="details.carrierTrackingUrl" target="_blank" rel="noopener noreferrer">
                <em aria-hidden="true" class="pi pi-globe mr--4"></em>
                {{ 'pages.transport.tracking-tabs.open-carrier-page' | translate }}
              </a>
            }
          </div>
        </div>
        <transport-details [details]="details"></transport-details>
      }
    }

    @if (errorMessage(); as error) {
      <div class="pt--32 pb--32">
        <p-message [closable]="false" severity="error" variant="outlined" size="large" icon="pi pi-times-circle" [text]="error"></p-message>
      </div>
    }
  </div>
</div>
